import EditTaskAddressModal from './EditTaskAddressModal';

export default EditTaskAddressModal;
